import React from 'react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

const ViewModal = ({ reservation, onClose }) => {
  const brandColor = '#ae7d54';

  const handleDownloadPdf = () => {
    const input = document.getElementById('voucher-print-area');
    const downloadBtn = document.getElementById('hide-in-pdf');
    const closeBtn = document.getElementById('hide-close-btn');
    
    if(downloadBtn) downloadBtn.style.display = 'none';
    if(closeBtn) closeBtn.style.display = 'none';

    html2canvas(input, { 
      scale: 3, 
      useCORS: true,
      backgroundColor: "#ffffff"
    }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(`Voucher_${reservation.name}.pdf`);
      
      if(downloadBtn) downloadBtn.style.display = 'block';
      if(closeBtn) closeBtn.style.display = 'block';
    });
  };

  return (
    <div style={modalOverlayStyle}>
      <div style={modalContainerStyle} id="voucher-print-area">
        {/* Header using Brand Color #ae7d54 */}
        <div style={{ ...headerStyle, backgroundColor: brandColor }}>
          <button id="hide-close-btn" style={closeIconStyle} onClick={onClose}>&times;</button>
          <div style={iconCircle}>
            <i className="fas fa-coffee" style={{ color: brandColor }}></i>
          </div>
          <h2 style={{ margin: '12px 0 0', fontSize: '20px', fontWeight: '700', letterSpacing: '0.5px' }}>
            Reservation Voucher
          </h2>
          <p style={{ margin: '4px 0 0', fontSize: '13px', opacity: 0.9 }}>ID: #RES-{reservation.id}</p>
        </div>

        <div style={{ padding: '25px' }}>
          {/* Cafe Branding */}
          <div style={{ textAlign: 'center', marginBottom: '25px' }}>
            <h3 style={{ margin: 0, color: '#2b2b2b', fontSize: '22px', fontWeight: '800' }}>The Porch Cafe & Restaurant</h3>
            <p style={{ margin: '4px 0', color: '#7a7a7a', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '1px' }}>
              Hotel The Pride, Kota, Rajasthan
            </p>
          </div>

          <div style={detailsBoxStyle}>
            <div style={gridStyle}>
              <DetailItem label="Guest Name" value={reservation.name} />
              <DetailItem label="Status" value={reservation.status} isStatus />
              
              <DetailItem label="Date" value={new Date(reservation.date).toLocaleDateString()} />
              <DetailItem label="Time" value={reservation.time} />
              
              {/* Added No. of Persons Field */}
              <DetailItem label="No. of Persons" value={`${reservation.persons} Persons`} />
              <DetailItem label="Phone" value={reservation.phone} />
              
              <DetailItem label="Email" value={reservation.email} fullWidth />
            </div>
          </div>

          {/* Action Button using Brand Color #ae7d54 */}
          <button 
            id="hide-in-pdf" 
            style={{ ...downloadButtonStyle, backgroundColor: brandColor }} 
            onClick={handleDownloadPdf}
          >
            <i className="fas fa-file-pdf" style={{ marginRight: '8px' }}></i>
            Download Voucher
          </button>
        </div>
      </div>
    </div>
  );
};

// --- Sub-component for Details ---
const DetailItem = ({ label, value, fullWidth = false, isStatus = false }) => (
  <div style={{ gridColumn: fullWidth ? '1 / span 2' : 'span 1', marginBottom: '15px' }}>
    <p style={{ margin: '0 0 4px', fontSize: '11px', fontWeight: '700', color: '#999', textTransform: 'uppercase' }}>{label}</p>
    {isStatus ? (
       <span style={{ 
         padding: '4px 10px', borderRadius: '4px', fontSize: '11px', fontWeight: '700',
         backgroundColor: value === 'Cancelled' ? '#fff1f0' : '#f6ffed',
         color: value === 'Cancelled' ? '#cf1322' : '#389e0d',
         border: `1px solid ${value === 'Cancelled' ? '#ffa39e' : '#b7eb8f'}`
       }}>{value}</span>
    ) : (
      <p style={{ margin: 0, fontSize: '15px', color: '#333', fontWeight: '600' }}>{value || 'N/A'}</p>
    )}
  </div>
);

// --- Styles ---
const modalOverlayStyle = {
  position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.7)',
  display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 2000, backdropFilter: 'blur(4px)'
};

const modalContainerStyle = {
  backgroundColor: '#fff', width: '95%', maxWidth: '420px', borderRadius: '12px',
  overflow: 'hidden', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)'
};

const headerStyle = {
  padding: '35px 20px', textAlign: 'center', color: '#fff', position: 'relative'
};

const iconCircle = {
  width: '45px', height: '45px', background: '#fff', borderRadius: '50%',
  display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto',
  fontSize: '18px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
};

const closeIconStyle = {
  position: 'absolute', top: '15px', right: '15px', background: 'transparent',
  border: 'none', color: '#fff', fontSize: '24px', cursor: 'pointer'
};

const detailsBoxStyle = {
  background: '#fafafa', padding: '20px', borderRadius: '8px', border: '1px solid #f0f0f0'
};

const gridStyle = { 
  display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px' 
};

const downloadButtonStyle = {
  width: '100%', marginTop: '20px', padding: '14px', borderRadius: '8px', border: 'none',
  color: '#fff', fontWeight: '700', fontSize: '15px', cursor: 'pointer', transition: 'opacity 0.2s'
};

export default ViewModal;